import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../../common/customTable/CustomTable";

const COLUMNS = [
	{
		accessorKey: "para",
		header: "Para",
		size: 120,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
		 muiTableBodyCellProps: {
            sx: {
                fontWeight: "bold !important",
            },
        },
	},
	{
		accessorKey: "description",
		header: "Description",
		size: 380,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
		muiTableBodyCellProps: {
			sx: {
				fontWeight: "bold !important",
			},
		},
	},
	{
		accessorKey: "co2Ets",
		header: "CO2 ETS",
		size: 120,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
	},
	{
		accessorKey: "ch4Ets",
		header: "CH4 ETS",
		size: 120,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
	},
	{
		accessorKey: "n2oEts",
		header: "N2O ETS",
		size: 120,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
	},
	{
		accessorKey: "meEts",
		header: "ME ETS",
		size: 130,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
	},
];

const AggregatedEmissionDataTab = ({
	inPortActivitiesEmissions,
	voyagesOtherThanSub,
	voyagesBetweenGINI,
	totalMaritimeEmissions,
}) => {
	const data = useMemo(
		() => [
			{
				para: "38-(1)(a)(vi)",
				description:
					"Aggregated maritime emissions from all in-port activities",
				...(inPortActivitiesEmissions || {}),
			},
			{
				para: "38-(1)(a)(vii)",
				description:
					"Aggregated maritime emissions from all voyages other than those in sub paragraph (viii)",
				...(voyagesOtherThanSub || {}),
			},
			{
				para: "38-(1)(a)(viii)",
				description:
					"Aggregated maritime emissions from all voyages between Great Britain and Northern Ireland",
				...(voyagesBetweenGINI || {}),
			},
			{
				para: "38-(1)(a)(ix)",
				description:
					"Total aggregated maritime emissions from all maritime activities",
				...(totalMaritimeEmissions || {}),
			},
		],
		[
			inPortActivitiesEmissions,
			voyagesOtherThanSub,
			voyagesBetweenGINI,
			totalMaritimeEmissions,
		]
	);

	return (
		<div className="p-2">
			<CustomTable
				renderTableData={data}
				columnsData={COLUMNS}
				customProps={{
					header: <strong>Aggregated Emission Data</strong>,
					enableToptoolbar: true,
					enableSort: false,
					enableColumnVirtualization: false,
					enableRowVirtualization: false,
					isLoading: false,
					tableName: "aggregated-emission-data",
					decimalPlaces: 5,
				}}
			/>
		</div>
	);
};

export default AggregatedEmissionDataTab;